import { ClaimTypeCode } from '@quromedical/fhir-common';
import { z } from 'zod';
import { DisplayReferenceSchema, UUIDSchema } from '../domain/models';

export const ClaimTemplateChargeLineQuantitySchema = z.object({
  /**
   * ID of the `ChargeItemDefinition` in FHIR
   */
  chargeLine: UUIDSchema,
  quantity: z.number(),
});
export type ClaimTemplateChargeLineQuantity = z.infer<
  typeof ClaimTemplateChargeLineQuantitySchema
>;

export const ClaimTemplateBaseSchema = z.object({
  type: z.nativeEnum(ClaimTypeCode),
  chargeLines: ClaimTemplateChargeLineQuantitySchema.array(),
});
export const ClaimTemplateCreateRequestSchema = ClaimTemplateBaseSchema;
export const ClaimTemplateUpdateRequestSchema = ClaimTemplateBaseSchema;

export const ClaimTemplateSchema = ClaimTemplateBaseSchema.extend({
  lastModified: z.number(),
  lastModifiedBy: UUIDSchema,
});
/**
 * A Claim template is the basis off which a claim is generated
 */
export type ClaimTemplate = z.infer<typeof ClaimTemplateSchema>;

export type ClaimTemplateBaseRequest = z.infer<typeof ClaimTemplateBaseSchema>;
export type ClaimTemplateCreateRequest = z.infer<
  typeof ClaimTemplateCreateRequestSchema
>;
export type ClaimTemplateUpdateRequest = z.infer<
  typeof ClaimTemplateUpdateRequestSchema
>;

export type ClaimTemplateUpdateResponse = z.infer<typeof ClaimTemplateSchema>;

export const ClaimTemplateChargeLineReferenceQuantitySchema = z.object({
  reference: DisplayReferenceSchema,
  quantity: z.number(),
});
export type ClaimTemplateChargeLineReferenceQuantity = z.infer<
  typeof ClaimTemplateChargeLineReferenceQuantitySchema
>;

export const ClaimTemplateGetTypeRequestSchema = z.object({
  type: z.nativeEnum(ClaimTypeCode),
});

export const ClaimTemplateGetResponseSchema = z.object({
  id: z.nativeEnum(ClaimTypeCode),
  lastModified: z.number(),
  lastModifiedBy: z.string(),
  type: z.nativeEnum(ClaimTypeCode),
  chargeLines: ClaimTemplateChargeLineReferenceQuantitySchema.array(),
});
export type ClaimTemplateGetResponse = z.infer<
  typeof ClaimTemplateGetResponseSchema
>;

export const ClaimTemplateGetAllResponseSchema = z.object({
  claimTemplates: ClaimTemplateSchema.extend({
    id: z.nativeEnum(ClaimTypeCode),
  }).array(),
});
export type ClaimTemplateGetAllResponse = z.infer<
  typeof ClaimTemplateGetAllResponseSchema
>;

export const ClaimTemplateLambdaGetInputSchema = z.object({
  type: z.nativeEnum(ClaimTypeCode),
});
export type ClaimTemplateLambdaGetInput = z.infer<
  typeof ClaimTemplateLambdaGetInputSchema
>;

export type ClaimTemplateLambdaGetResult = ClaimTemplate | undefined;

export type ClaimTemplateLambdaPutInput = ClaimTemplate;
export type ClaimTemplateLambdaPutResult = ClaimTemplate;

export type ClaimTemplateLambdaGetAllInput = undefined;
export type ClaimTemplateLambdaGetAllResult = ClaimTemplate[];
